import { __awaiter, __rest } from "tslib";
import React from 'react';
const Iconfont = (props) => {
    const { iconMode, className = '', width, height, style = {}, type } = props, restProps = __rest(props, ["iconMode", "className", "width", "height", "style", "type"]);
    if (iconMode === 'svg') {
        const iconStyle = Object.assign(Object.assign({}, style), { width: width || height || '1em', height: height || width || '1em' });
        return (React.createElement("span", { className: className || '' },
            React.createElement("svg", { "aria-hidden": "true", style: iconStyle },
                React.createElement("use", { xlinkHref: `#${(type || '').startsWith('icon-') ? type : `icon-${type}`}` }))));
    }
    return (React.createElement("i", Object.assign({ style: style, className: `iconfont ${(type || '').startsWith('icon-') ? type : `icon-${type}`} ${className}` }, restProps)));
};
Iconfont.loadIconfont = (iconfontVersion) => {
    loadStyle(`//at.alicdn.com/t/${iconfontVersion}.css`);
    loadScript(`//at.alicdn.com/t/${iconfontVersion}.js`);
};
const getStyle = (url) => {
    const links = Array.from(document.getElementsByTagName('link'));
    if (links.find((link) => link.href === url)) {
        return;
    }
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
};
export const loadStyle = (url) => {
    if (!url) {
        return;
    }
    if (Array.isArray(url)) {
        url.forEach((value) => {
            getStyle(value);
        });
    }
    else {
        getStyle(url);
    }
};
export const loadScript = (url, callback) => __awaiter(void 0, void 0, void 0, function* () {
    if (!url) {
        return;
    }
    if (Array.isArray(url)) {
        for (const currentValue of url) {
            if (Array.isArray(currentValue)) {
                /* eslint no-await-in-loop:0 */ /* design to wait to execute one by one */
                yield Promise.all(currentValue.map((value) => getJS(value)));
            }
            else if (currentValue) {
                yield getJS(currentValue);
            }
        }
    }
    else {
        yield getJS(url);
    }
    if (callback) {
        callback();
    }
});
export const getJS = (url) => new Promise((resolve, reject) => {
    if (!url) {
        resolve('empty url');
    }
    const scripts = Array.from(document.getElementsByTagName('script'));
    if (scripts.find((script) => script.src === url)) {
        resolve(`duplicate: ${url}`);
        return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.crossOrigin = 'anonymous';
    if (script.readyState) {
        // IE
        script.onreadystatechange = function () {
            if (script.readyState === 'loaded' ||
                script.readyState === 'complete') {
                script.onreadystatechange = null;
                resolve(`success: ${url}`);
            }
        };
    }
    else {
        // Others
        script.onload = function () {
            resolve(`success: ${url}`);
        };
    }
    script.onerror = function () {
        // reject(Error(`${url}: load error!`));
        console.log(Error(`${url}: load error!`));
    };
    script.src = url;
    document.body.appendChild(script);
});
export default Iconfont;
//# sourceMappingURL=index.js.map